import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import './ant-css-fix.scss';

import App from './App';
import store from './store';
import { Provider } from 'react-redux';
import reportWebVitals from './reportWebVitals';
import ServiceComponent from '@aimakerspace/eliteu-service-react'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <Provider store={store}>
      <ServiceComponent title="英荔 AI 实验平台" chatStyle={{ display: 'inline-block', right: '110px', bottom: '70px' }} chatH5Style={{ display: 'inline-block' }} />
      <App />
    </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
